import React from "react";

const ImageInBackground = ({ imageUrl, ...props }) => {
  return (
    <>
      <div className={props.className} style={{ backgroundImage: `url(${imageUrl})` }}>
        {props.children}
      </div>
    </>
  );
};

export default ImageInBackground;
